import api from './api';

export interface AtivacaoContratoAdministrador {
  usuarioId: string;
  nome: string;
  email?: string;
  cargo?: string;
  configuracaoId?: string;
  ordem?: number;
  selecionado: boolean;
  ativo: boolean;
}

export const getAtivacaoContratoAdministradores = () =>
  api.get<AtivacaoContratoAdministrador[]>('ativacaoContratoAdministradores');

export const updateAtivacaoContratoAdministradores = (values: {
  administradores: Array<{ usuarioId: string; ordem: number; selecionado: boolean }>;
}) => api.put<any>('ativacaoContratoAdministradores', values);
